module.exports = __webpack_public_path__ + "c829e5092991407ce806777df7815da0.svg";